import React, {  useState } from "react";

// reactstrap components
import { Button, Card, CardHeader, CardBody, FormGroup, CustomInput, Form, Input, Container, Row, Col} from "reactstrap";
// core components
//import UserHeader from "components/Headers/UserHeader.js";
import EditHeader from "../../components/Headers/EditHeader";
import { edit } from "../../network/ApiAxios";
import { editt } from "../../network/ApiAxios";

const EditProfile = (props) => {
  let user = JSON.parse(localStorage.getItem("user"));

  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [phone, setPhone] = useState(user.phone);
  const [birthday, setbirthday] = useState(user.birthday);
  const [adress, setAdress] = useState(user.adress);
  const [country, setCountry] = useState(user.country);
  const [facebook, setFacebook] = useState(user.facebook);
  const [instagram, setInstagram] = useState(user.instagram);
  const [Picture, setPicture] = useState(null);
  const [IDpicture, setIDpicture] = useState(null);
  const [driverlicense, setDriverlicense] = useState(null);

  const editUser = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("picture", Picture);
    formData.append("IDpicture", IDpicture);
    formData.append("driverlicense", driverlicense);
    formData.append("userID", user._id);
    formData.append("email", user.email);

    // eslint-disable-next-line
    const responsee = await editt(formData);
    const response = await edit(
      user._id,
      name,
      email,
      phone,
      birthday,
      adress,
      country,
      facebook,
      instagram
    );

    const { data } = response;

    if (data.success) {
      user = {
        ...user,
        name,
        email,
        phone,
        birthday,
        adress,
        country,
        facebook,
        instagram,
      };
      console.log(user.role)
      localStorage.setItem("user", JSON.stringify(user));
      props.history.push("/" + user.role + "/profile");
    }
  };

  return (
    <>
      <EditHeader /> {/* Page content */}{" "}
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0"> My account </h3>{" "}
                  </Col>{" "}
                  <Col className="text-right" xs="4">
                    <Button
                      color="primary"
                      type="submit"
                      form="myform"
                      //onClick={editUser}
                      size="sm"
                    >
                      Save{" "}
                    </Button>{" "}
                  </Col>{" "}
                </Row>{" "}
              </CardHeader>{" "}
              <CardBody>
                <Form id="myform" onSubmit={editUser}>
                  <div className="pl-lg-4">
                    <h6 className="heading-small text-muted mb-4">
                      User information{" "}
                    </h6>{" "}
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Username{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={name}
                            id="input-username"
                            placeholder="Username"
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Email address{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            id="input-email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-phone"
                          >
                            Phone Number{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={phone}
                            id="input-phone"
                            placeholder="Phone"
                            onChange={(e) => setPhone(e.target.value)}
                            type="number"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-birthday"
                          >
                            Birthday{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={birthday}
                            id="input-birthday"
                            onChange={(e) => setbirthday(e.target.value)}
                            type="date"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                    <Row>
                      <Col lg="6">
                        <FormGroup hidden>
                          <label
                            className="form-control-label"
                            htmlFor="input-phone"
                          >
                            Phone Number{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={phone}
                            id="input-phone"
                            placeholder="Phone"
                            onChange={(e) => setPhone(e.target.value)}
                            type="number"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-profilepicture"
                          >
                            Profile Picture{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            //value={Picture}
                            id="input-profilepicture"
                            onChange={(e) => setPicture(e.target.files[0])}
                            type="file"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User Address{" "}
                    </h6>{" "}
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-adress"
                          >
                            Address{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            id="input-adress"
                            placeholder="Address"
                            value={adress}
                            onChange={(e) => setAdress(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-country"
                          >
                            Country{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={country}
                            id="input-country"
                            placeholder="Country"
                            onChange={(e) => setCountry(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User social information{" "}
                    </h6>{" "}
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-facebook"
                          >
                            Facebook{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={facebook}
                            id="input-facebook"
                            placeholder="Facebook link"
                            onChange={(e) => setFacebook(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-instagram"
                          >
                            Instagram{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            id="input-instagram"
                            placeholder="Instagram Link"
                            value={instagram}
                            onChange={(e) => setInstagram(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User ID and Drivers license{" "}
                    </h6>{" "}
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            ID picture{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            //value={IDpicture}
                            id="input-idpicture"
                            onChange={(e) => setIDpicture(e.target.files[0])}
                            type="file"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Picture Drivers License{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            id="input-driverlicense"
                            //value={driverlicense}
                            onChange={(e) =>
                              setDriverlicense(e.target.files[0])
                            }
                            type="file"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                  </div>{" "}
                </Form>{" "}
              </CardBody>{" "}
            </Card>{" "}
          </div>{" "}
        </Row>{" "}
      </Container>{" "}
    </>
  );
};

export default EditProfile;
